<template>
  <div>
    <ThirdPartyServiceProductList :third-party-service-products="thirdPartyServiceProducts" />
  </div>
</template>

<script>
import ThirdPartyServiceProductList from './ThirdPartyServiceProductList.vue';

export default {
  components: {
    ThirdPartyServiceProductList,
  },
  props: {
    accProductId: {
      type: String,
      required: true,
    },
  },
  computed: {
    accProduct() {
      return this.$store.state.entities.accProducts.byId[this.accProductId];
    },
    thirdPartyServiceProducts() {
      const { thirdPartyServiceProducts = [] } = this.accProduct || {};

      return thirdPartyServiceProducts.map(
        (id) => this.$store.state.entities.thirdPartyServiceProducts.byId[id]
      );
    },
  },
};
</script>
